export class ProviderError extends Error {
	constructor(readonly type: string, error: Error | string) {
		super(error.toString());
	}
}
